import * as types from '../actions/types';

const initialState = {
  token: {},
  profile: {
    id: undefined,
    first_name: undefined,
    last_name: undefined,
    email: undefined,
    groups: undefined,
    acl: undefined,
    loading: false,
    passkey_auth: false,
  },
  emailExists: false,
  verify: {
    valid: false,
    status: 'checking'
  },
  verificationSucceed: true,
  emailResend: false,
  tablesSearches: {},
};

const reducer = function (state = initialState, action) {
  switch(action.type) {
    case types.USER_INFO_LOADING:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: true
        }
      };
    case types.USER_INFO:
      const { id, first_name, last_name, email, acl, groups, passkey_auth } = action.payload;
      let loading = state.profile.loading;
      if (id) {
        loading = false;
      }
      return {
        ...state,
        profile: {
          id,
          first_name,
          last_name,
          email,
          acl: acl,
          groups: groups,
          loading: loading,
          passkey_auth: passkey_auth || false,
        }
      };
    case types.TOKEN_DETAILS:
      const { access_token, expires_at, refresh_token } = action.payload;
      return {
        ...state,
        token: {
          access_token,
          expires_at,
          refresh_token
        }
      };
    case types.EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        verificationSucceed: action.payload.verificationSucceed
      };
    case types.EMAIL_VERIFICATION_RESEND:
      return {
        ...state,
        emailResend: action.payload.emailResend
      };
    case types.TABLES_SEARCHES:
      return {
				...state,
				tablesSearches: action.payload.tablesSearches || null,
      };
		case types.RESET_TABLES_SEARCHES:
			return {
				...state,
				tablesSearches: null,
			};
    default:
      return state;
  }
};

export default reducer;
